module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASElEQVQ4y83U2wkAIAxD0UAH6Eiu7kgOUIgPENzAm6+cv0Jp5SdDn9V10/4r7V0QOkO5EMrSXhZCCq8axihLBJ1ihkA3zfl1EzBQlAG1qSVmAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQzKzA5OjAweQ3b9QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00343_100x100.png
// module id = Zi1Z
// module chunks = 0